import React from 'react'
import { Button, Form } from 'semantic-ui-react'
import { Icon, Modal } from 'semantic-ui-react';
import PJModal from '../componentsHelpers/Modal';
import { getUUID } from '../api/request';

import FormikInputField from '../componentsFormik/FormikInputField';

import styled from "styled-components";

const RedText = styled.p`
  color: red;
  animation: fadein 1s;

  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

class EmailForm extends React.Component<any, any> {
  state = { wrongEmail: '', modalOpen: false, modalSize: 'mini', modalContent: null };

  prev = (e: any) => {
    e.preventDefault();
    this.props.manualStep(1, null, 16.67, null);
  };


  nextStep = () => {
    this.props.submitForm().then(() => {
      if (this.props.isValid) {
        this.fetchLeadUUID();
      }
    });
  };

  fetchLeadUUID = () => {
    const { email_input } = this.props.values;

    this.setState({ modalOpen: true, modalContent: this.modalContent('Checking your email', '', true) });

    getUUID(email_input)()
      .then(response => {
        const { data } = response;
        this.props.routeLead(data.uuid);
      })
      .catch(error => {
        this.props.setFieldValue('email_input', '');
        this.setState({ wrongEmail: email_input, modalOpen: false });
      });
  };

  modalContent = (title: string, msg?: string, spinner?: boolean) => {
    return (
      <React.Fragment>
        <Modal.Header style={{ textAlign: 'center' }}>{title}</Modal.Header>
        <Modal.Content style={{ textAlign: 'center' }}>
          {spinner ? <Icon loading name='spinner' size='massive' /> : null}
          <br />
          {msg ? <p>{msg}</p> : null}
        </Modal.Content>
      </React.Fragment>
    );
  };

  render() {
    return (
      <React.Fragment>
        <Form.Group grouped>
          {
            this.state.wrongEmail ? <RedText className="error">{
              `We can't seem to find ${this.state.wrongEmail} in our records, please ensure you have typed it correctly. 
            Alternatively you can contact us at boots@payjustice.co.uk or 0161 883 3468. Alternatively, you can go back 
            to the form by pressing the 'Back' button below.`}</RedText> : null
          }
          <FormikInputField
            label="Enter the email you used to register:"
            name="email_input"
            type="input"
            placeholder="your@email.co.uk"
          />
          <Button.Group widths="2">
            <Button
              labelPosition="left"
              floated="left"
              color="grey"
              icon="left chevron"
              content="Back"
              type="button"
              onClick={this.prev}
            />
            <Button
              labelPosition="right"
              floated="right"
              color={this.props.isValid ? 'green' : 'grey'}
              icon="right chevron"
              content="Next"
              type="button"
              onClick={this.nextStep}
            />
          </Button.Group>
        </Form.Group>
        <PJModal
          size={this.state.modalSize}
          open={this.state.modalOpen}
          content={this.state.modalContent}
        />
      </React.Fragment>
    )
  }
}

export default EmailForm;